import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { TAccount } from '@helpers/Accounts/accounts.types';
import { getTopUpStatus } from '@helpers/GetTopUpStatus/getTopUpStatus';
import { fetchGetApplication } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

type TUseGetWithdrawalSummaryData = {
    outstandingPrincipalWithFee: number;
    otherFees: number;
    isTopUpApproved: boolean;
};

export const useGetWithdrawalSummaryData = (
    accountId: NonNullable<TAccount['account_id']>
): TUseGetWithdrawalSummaryData => {
    const stateKey = useStateKey();
    const { data: account } = useQuery({
        ...getAccountsQueryConfig(stateKey),
        select: (data) =>
            data.data.accounts.find(
                (account) => account.account_id === accountId
            ),
        suspense: true
    });
    const { data: applicationResponse } = useQuery({
        queryKey: ['application', stateKey],
        queryFn: () =>
            fetchGetApplication({
                stateKey
            }),
        suspense: true
    });

    if (!account || !applicationResponse) {
        throw new Error();
    }

    return {
        outstandingPrincipalWithFee: account.pending_balance!.total || 0,
        otherFees: account.pending_balance!.other_fees || 0,
        isTopUpApproved:
            getTopUpStatus(account, applicationResponse.data) ===
            'TOPUP_APPROVED'
    };
};
